import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const providerAvailabilityApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProviderAvailabilities: builder.query({
      query: filters => {
        const qs = Object.keys(filters || {}).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `provider_availability/?${qs}`;
      },
      providesTags: ['ProviderAvailability'],
    }),
    createProviderAvailability: builder.mutation({
      query: (body) => ({
        url: 'provider_availability/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ProviderAvailability'],
    }),
    updateProviderAvailability: builder.mutation({
      query: ({ id, body }) => ({
        url: `provider_availability/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ProviderAvailability'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetProviderAvailabilitiesQuery,
  useCreateProviderAvailabilityMutation,
  useUpdateProviderAvailabilityMutation,
} = providerAvailabilityApi;

